import { CHAT_LIST_PANEL_WIDTH_PX } from 'layout/MainLayout/layout-zoom-constants';

// theme constant
export const gridSpacing = 3;

// ==============================|| Scrollbar — אזור פגיעה רחב (×3), אצבע צרה שמתרחבת ב-hover ||============================== //
/** רוחב מסילה כשלא בריחוף — צר (מצטמצם פס) */
export const SCROLLBAR_TRACK_COLLAPSED_PX = 6;
/** רוחב מסילה בריחוף על אזור הפס — מורחב, נוח לגרירה */
export const SCROLLBAR_BASE_TRACK_PX = 14;
/** מכפיל: רוחב מסילת ה-hit המלאה = בסיס × מכפיל (למשל 14×3 = 42px) — כל הרוחב קולט עכבר גם כשהאצבע צרה */
export const SCROLLBAR_HIT_ZONE_MULTIPLIER = 3;
export const SCROLLBAR_TRACK_HIT_WIDTH_PX = SCROLLBAR_BASE_TRACK_PX * SCROLLBAR_HIT_ZONE_MULTIPLIER;
/** ליבת הצבע של האצבע (לא כולל מסגרת שקופה / טבעת) — דק */
export const SCROLLBAR_THUMB_DEFAULT_WIDTH_PX = 2;
/** ליבת האצבע בריחוף — עדיין צר מול רוחב המסילה (לא מילוי מלא) */
export const SCROLLBAR_THUMB_HOVER_CORE_PX = 4;
export const SCROLLBAR_TRANSITION = 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)';

/** גובה ה-header הראשי ב-Berry (MainLayout) — תואם ל־MainContentStyled marginTop */
export const appLayoutHeaderOffsetPx = 88;
export const drawerWidth = 260;
export const appDrawerWidth = 380;
/** רוחב בר שיחות — גרירה. מינ' מאפשר צמצום עד יישור שורת הפילטרים מעל החיפוש עם האייקונים */
export const chatListPanelWidthMin = 360;
export const chatListPanelWidthMax = 640;
/** ברירת מחדל לרוחב פאנל רשימת השיחות — מסונכן ל־`CHAT_LIST_PANEL_WIDTH_PX` */
export const chatListPanelWidthPx = CHAT_LIST_PANEL_WIDTH_PX;
export const chatListPanelWidthStorageKey = 'chatListPanelWidthPx';
/** עמודת תגית — רוחב מינימלי כשהבר מצומצם (יורד עם הרוחב; התגיות נשארות בעמודה מיושרת) */
export const chatListRowLabelColumnWidthMinPx = 56;
/** עמודת תגית — רוחב מקסימלי */
export const chatListRowLabelColumnWidthPx = 120;
export const appSidebarWidth = 320;

/** רוחב מגירה מצומצמת (מיני סרגל) — layout מסוג mini (legacy; רייל הקאנבס — ‎botBuilderCanvasRailWidthPx‎) */
export const miniDrawerWidth = 72;

/** רוחב בר הכלים הצדדי בקאנבס React Flow (בוט בילדר V2) — מאוזן לכפתורים ולטקסט בעברית */
export const botBuilderCanvasRailWidthPx = 80;

/** תוכן טאבים בהתאמה אישית — min-height מול viewport כששרשרת height % לא מעבירה גובה */
export const customizationTabOutletMinHeight = 'calc(100vh - 280px)';

/** Fade לתוכן Outlet בטאבים — עקבי עם ‎.cursor/rules/ui-ux-entry-experience.mdc‎ (300–500ms) */
export const tabOutletFadeMs = 400;

export const LOAD_MESSAGES_COUNT = 20;
export const LOAD_MORE_MESSAGES_COUNT = 100;

export const noWhatsappErr = 'No phone number WhatsApp account';
